import { render, staticRenderFns } from "./SupporterDetails.vue?vue&type=template&id=33dea815&"
import script from "./SupporterDetails.vue?vue&type=script&lang=js&"
export * from "./SupporterDetails.vue?vue&type=script&lang=js&"
import style0 from "./SupporterDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports